/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SpecialEnrollmentStatus {
  UNRESOLVED = 'UNRESOLVED',
  NONE = 'NONE',
  QLE = 'QLE',
  OFFERED_ICHRA = 'OFFERED_ICHRA',
}
